// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toggleOption":"rxc8tXbvk2aBoZN4Uwsw","optionName":"vr2Zm0qVpiI7cVIeIMqi","toggler":"HPp09j9pDC23g1JbvZwj","optionResultsCount":"AHhYRlBgCi5izie4tUKG"};